export default {
      id: "common__remove_lg-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__remove_lg",
      toString: function () {
        return this.url;
      }
    }